import moment from "moment";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { getContractAcGroupManageAsync } from "src/api/access/ac-group-api";
import { Ac2AccessGroupModel } from "src/api/access/ac-group-types";
import { getAccessGroupListAsync } from "src/api/access/productac-api";
import { getBuildingAsync } from "src/api/building/building-api";
import { MgmtOfficerType } from "src/api/building/building-types";
import { getBuildingManagementAsync } from "src/api/building/management-api";
import { moveMediaFilesAsync } from "src/api/file/file-api";
import { useApiOperation } from "src/api/hooks";
import { providerDetailAsync } from "src/api/provider/provider-api";
import { MediaFile } from "src/api/public-types";
import { getConnectedInfoListAsync } from "src/api/question/qeustion-api";
import { getVisitorsAsync, patchContractVisitorAsync, postVisitorAsync } from "src/api/visitor/visitor-api";
import {
  WorkOrderCancelAsync,
  WorkOrderDetailAsync,
  WorkOrderEditAsync,
  WorkOrderListAsync,
  WorkOrderPostAsync,
  getWorkOrderPreviewAsync,
  postWorkOrderGoupIdAsync,
} from "src/api/work-order/workorder-api";
import {
  WorkOrderDetailModel,
  WorkOrderFormType,
  WorkOrderPreivew,
  WorkOrderPreviewRequest,
  WorkOrderQueryParams,
} from "src/api/work-order/workorder-types";
import useNavigate from "src/hooks/usePartnerNavigate";
import { useQueryParams } from "src/hooks/useQueryParams";
import { PagePath } from "src/pages/product/details";
import { YmdFormat } from "src/utils";
import { UnionRecurrenceType } from "../workOrder-types";

const useWorkOrder = () => {
  const navigate = useNavigate();
  const defaultValues = useMemo(() => {
    const workOrderFormData: WorkOrderFormType = {
      // workOrderType: WorkOrderType.SPACE,
      workOrderSheetAccessZoneList: [
        {
          cmdType: "C",
          // mgmtOfficerId: "",
          contractManageId: "",
          contractId: "",
          startDate: moment().format(YmdFormat.WITH_TIME_ZONE),
          endDate: moment().endOf("days").format(YmdFormat.WITH_TIME_ZONE),
          startTime: "",
          endTime: "",
        },
      ],
      // workOrderPriority: 2,
      accessType: "TIME",
      mgmtOfficeId: "",
      mgmtOfficerId: "",
      startDate: moment().format(YmdFormat.WITH_TIME_ZONE),
      endDate: moment().endOf("days").format(YmdFormat.WITH_TIME_ZONE),
      summary: "",
      description: "",
      isSendAlarm: true,
    };

    return workOrderFormData;
  }, []);

  const { queryParams } = useQueryParams();
  const { id } = useParams();

  const workOrderId = useMemo(() => {
    return queryParams?.id ? String(queryParams.id) : String(id);
  }, [queryParams.id, id]);

  const [buildingId, setBuildingId] = useState("");

  // 워크오더 상세 api
  const { executeAsync: getWorkOrderDetail } = useApiOperation(WorkOrderDetailAsync);

  // 관리처 관리 상세
  const { executeAsync: getBuildingManagement } = useApiOperation(getBuildingManagementAsync);

  // 건물 상세 조회 api
  const { executeAsync: getBuilding } = useApiOperation(getBuildingAsync);

  // 워크오더 반복일정 api
  const { executeAsync: getWorkOrderPreview } = useApiOperation(getWorkOrderPreviewAsync);

  // 워크오더 등록 api
  const { executeAsync: postWorkOrder } = useApiOperation(WorkOrderPostAsync);

  // 워크오더 수정 api
  const { executeAsync: editWorkOrder } = useApiOperation(WorkOrderEditAsync);

  // 프로바이더 상세조회
  const { executeAsync: getProviderDetail } = useApiOperation(providerDetailAsync);

  // 워크오더 취소 api
  const { executeAsync: workOrderCancel } = useApiOperation(WorkOrderCancelAsync);

  // 그룹 id 생성
  const { executeAsync: postWorkOrderGroupId } = useApiOperation(postWorkOrderGoupIdAsync);

  const { executeAsync: moveMedias } = useApiOperation(moveMediaFilesAsync);
  // 상담관리 연결정보
  const { executeAsync: getConnectedInfoList } = useApiOperation(getConnectedInfoListAsync);

  // 방문자 초대 요청
  const { executeAsync: postVisitor } = useApiOperation(postVisitorAsync);
  // 방문자 목록 조회
  const { executeAsync: getVisitors } = useApiOperation(getVisitorsAsync);
  // 방문자 수정
  const { executeAsync: editVisitor } = useApiOperation(patchContractVisitorAsync);

  const { executeAsync: getWorkOrderListApi } = useApiOperation(WorkOrderListAsync);

  //출입그룹 목록 조회
  const { executeAsync: getAccessList } = useApiOperation(getAccessGroupListAsync);

  const { executeAsync: getContractAcGroup } = useApiOperation(getContractAcGroupManageAsync);

  // 워크오더 목록 조회
  const getWorkOrderList = async (workOrderParams: WorkOrderQueryParams) => {
    const response = await getWorkOrderListApi(workOrderParams);
    const result = response.data.data.content;
    return result || [];
  };

  // 워크오더 그룹취소 및 방문자 전체 삭제
  const allCancelWorkOrderAndVisitor = async (groupId: string) => {
    const workOrderList = await getWorkOrderList({ page: 0, size: 999, keywordList: groupId, searchType: "GROUP_ID" });
    const filterCancelWorkOrder = workOrderList?.filter((item) => item.status !== "WORK_ORDER_CANCELED" && item.status !== "WORK_ORDER_CLOSED");
    if (filterCancelWorkOrder && filterCancelWorkOrder.length > 0) {
      // 워크오더 그룹취소
      await cancelWorkOrder(String(groupId));
      // 방문자 삭제
      await Promise.all(
        filterCancelWorkOrder.map(async (item) => {
          await onDeleteVisitor(String(item.id));
        }),
      );
    }
  };

  // 방문자 목록 조회
  const getVisitorsList = async (workOrderSheetId: string) => {
    const { data } = await getVisitors({ workOrderSheetId });
    const contractVisitor = data.data.contractVisitor;

    // 삭제된 방문자 제외
    return contractVisitor || [];
  };

  // 방문자 삭제
  const onDeleteVisitor = async (workOrderSheetId: string) => {
    const visitorList = await getVisitorsList(workOrderSheetId);
    if (visitorList && visitorList.length > 0) {
      // 오늘 기준 과거의 날짜는 제외하고 방문자 삭제 (당일 + 미래 날짜만 삭제)
      const sameOrAfterVisitorList = visitorList.filter(
        // 삭제된 방문자 제외
        (item) => item.isDeleted !== true && moment(item.visitStartTime).isSameOrAfter(moment(), "day"),
      );

      await Promise.all(
        sameOrAfterVisitorList.map((item) => {
          return editVisitor({
            contractVisitorList: [{ contractVisitorId: item.contractVisitorId, visitorName: item.visitorName, isDeleted: true }],
            contractVisitorGroupId: String(item.contractVisitorGroupId), // 방문자 그룹 id 워크오더  contractVisitorList 내려줄 수 있는지 확인
          });
        }),
      );
    } else {
      // 방문자 리스트가 0개일 때 워크오더 상세 페이지로 이동
      navigate(`${PagePath.workOrder.authenticated.detail.replace(":id", String(workOrderSheetId))}`);
    }
  };

  // 날짜 범위 생성 헬퍼 함수
  const generateDateRange = (startDate: string, endDate: string): string[] => {
    const dates: string[] = [];
    const start = moment(startDate);
    const end = moment(endDate);

    while (start.isSameOrBefore(end)) {
      dates.push(start.format("YYYY-MM-DD"));
      start.add(1, "day");
    }

    //  오늘 기준  과거의 날짜는 제외하고 방문자 초대 (당일 + 미래 날짜만 초대)
    return dates.filter((date) => moment(date).isSameOrAfter(moment(), "day"));
  };

  // 계약 출입그룹 ID 목록 조회
  const accessGroupAddIdsList = async (contractVisitorGroupId: string) => {
    const { data } = await getAccessList({ contractVisitorGroupId, visitorAccessYn: true });
    const acGroupIds = data.data.content.map((item: Ac2AccessGroupModel) => String(item.id));
    return acGroupIds;
  };

  // contractVisitorGroup 데이터 생성 공통 함수
  const createContractVisitorGroup = async (params: {
    contractManageId: string;
    date: string;
    timeInfo: { startTime: string; endTime: string };
    officer: MgmtOfficerType;
    workOrderSheetId: string | number;
    accessGroupIds?: string[];
  }) => {
    const { contractManageId, date, timeInfo, officer, workOrderSheetId, accessGroupIds } = params;

    return {
      contractManageId: Number(contractManageId),
      visitStartTime: moment(`${date} ${timeInfo.startTime}`).format(YmdFormat.WITH_TIME_ZONE),
      visitEndTime: moment(`${date} ${timeInfo.endTime}`).format(YmdFormat.WITH_TIME_ZONE),
      buildingId: Number(buildingId),
      workOrderSheetId: Number(workOrderSheetId),
      contractVisitorList: [
        {
          visitorName: officer?.name || "",
          visitorMobileNumber: officer?.phone || "",
        },
      ],
      accessGroupAddIdsList: accessGroupIds || [],
    };
  };

  // 방문자 재초대 (id 가 있으면 재초대 / 없으면 신규)
  const retryInviteVisitor = async (workrOrder: WorkOrderDetailModel, officerList: MgmtOfficerType[]) => {
    // 방문자 정보 조회
    console.log("workrOrder", workrOrder);
    const visitorInfo = await getVisitorsList(String(workOrderId)).then((res) => {
      console.log("방문자 목록", res);
      return res![0];
    });
    const { startDate, endDate } = workrOrder;
    const { contractManageId, visitStartTime, visitEndTime, contractVisitorGroupId } = visitorInfo;

    // 담당자 찾기
    const officer = officerList.find((item) => item.id === workrOrder.mgmtOfficerId);
    const dateRange = generateDateRange(startDate!, endDate!);

    const { data: contractAcGroup } = await getContractAcGroup({ contractManageId: Number(contractManageId) });

    console.log("contractAcGroup", contractAcGroup);
    // 계약 출입그룹 > 기본설정 / 커스텀 설정 확인 > true 일 때 기본권한 사용
    const visitorDefaultAccessGroupYn = contractAcGroup.data.contractManage.visitorDefaultAccessGroupYn;

    // 커스텀 권한인 경우 출입 그룹 ID 목록 조회
    const accessGroupIds = !visitorDefaultAccessGroupYn ? await accessGroupAddIdsList(String(contractVisitorGroupId)) : [];

    console.log("accessGroupIds", accessGroupIds);
    const apiRequests = dateRange.map(async (date) => {
      const contractVisitorGroup = await createContractVisitorGroup({
        contractManageId: String(contractManageId),
        date,
        timeInfo: {
          startTime: visitStartTime?.split("T")[1] || "",
          endTime: visitEndTime?.split("T")[1] || "",
        },
        officer: officer!,
        workOrderSheetId: String(workOrderId),
        accessGroupIds,
        // visitorDefaultAccessGroupYn,
      });
      console.log("contractVisitorGroup", contractVisitorGroup);
      // 방문자 초대
      return postVisitor({
        contractManageId: Number(contractManageId),
        contractVisitorGroup,
      });
    });

    // 4. 병렬 처리
    await Promise.all(apiRequests);
  };

  //  방문자 초대 요청 > 워크오더 신규 등록 시
  const onInviteVisitor = async (workOrderSheetList: WorkOrderFormType[], officerList: MgmtOfficerType[]) => {
    const workOrderGroupId = workOrderSheetList[0].workOrderSheetGroupId; // 워크오더 그룹 id
    const officer = officerList.find((item) => item.id === workOrderSheetList[0].mgmtOfficerId);

    // 워크오더 그룹 id 가 없을 때 (비정규 업무면)
    if (!workOrderGroupId) {
      const workOrderSheetId = workOrderSheetList[0].id;
      const accessZone = workOrderSheetList[0].workOrderSheetAccessZoneList![0];
      // 1. 시작날짜와 끝날짜 추출
      const startDate = accessZone.startDate.split("T")[0];
      const endDate = accessZone.endDate.split("T")[0];

      // 2. 날짜 범위 생성 (예: 15일, 16일, 17일)
      const dateRange = generateDateRange(startDate, endDate);

      // 3. 각 날짜별로 API 요청 데이터 생성
      const apiRequests = dateRange.map(async (date) => {
        const contractVisitorGroup = await createContractVisitorGroup({
          contractManageId: accessZone.contractManageId,
          date,
          timeInfo: {
            startTime: accessZone.startTime,
            endTime: accessZone.endTime,
          },
          officer: officer!,
          workOrderSheetId: workOrderSheetId!,
          accessGroupIds: accessZone.accessGroupAddIdsList || [],
        });

        return postVisitor({
          contractManageId: Number(accessZone.contractManageId),
          contractVisitorGroup,
        });
      });

      // 4. 병렬 처리
      await Promise.all(apiRequests);
    } else {
      const visitorGroupPromises = workOrderSheetList.flatMap((item, idx) => {
        const workOrderId = item.id;

        const accessZone = item.workOrderSheetAccessZoneList![0];
        const startDate = accessZone.startDate.split("T")[0];
        const endDate = accessZone.endDate.split("T")[0];

        const dateRange = generateDateRange(startDate, endDate);

        return dateRange.map(async (date) => {
          const contractVisitorGroup = await createContractVisitorGroup({
            contractManageId: accessZone.contractManageId,
            date,
            timeInfo: {
              startTime: accessZone.startTime,
              endTime: accessZone.endTime,
            },
            officer: officer!,
            workOrderSheetId: workOrderId!,
            accessGroupIds: accessZone.accessGroupAddIdsList || [],
          });

          return postVisitor({
            contractManageId: Number(accessZone.contractManageId),
            contractVisitorGroup,
          });
        });
      });

      // 모든 방문자 그룹 생성 및 API 호출을 병렬 처리
      await Promise.all(visitorGroupPromises);
    }
  };

  // 건물 관리처 담당자 조회
  const getBuildingOfficerInfo = async (mgmtOfficeId: string) => {
    let mgmtBuildingName = "";
    let officerList: MgmtOfficerType[] = [];
    // 관리처 상세 조회 response
    const { data } = await getBuildingManagement({ id: mgmtOfficeId });

    const managementBuilding = data.data.content;

    // 관리처 상세에 있는 buildingId
    const buildingId = managementBuilding.buildingId;
    setBuildingId(String(buildingId));

    const providerId = managementBuilding.providerId;

    if (buildingId) {
      const { data: building } = await getBuilding({ buildingId: Number(buildingId) });
      const buildingName: string = building?.data?.content?.building?.buildingName;
      let providerName = "없음";

      // 정산정보 상세에서 providerName 가져와서 표시 (관리처명)
      if (providerId !== null) {
        const { data } = await getProviderDetail({ providerId: String(providerId) });
        if (data) {
          providerName = String(data.data.provider?.providerName);
        }
      }
      // 건물/관리처 input value setState
      mgmtBuildingName = `${buildingName} / ${providerName}`;
    }

    //  작업자 목록
    const filteredOfficer = managementBuilding?.officerList?.filter((officer) => officer.isDeleted !== true);
    officerList = filteredOfficer || [];

    return {
      mgmtBuildingName,
      officerList,
    };
  };

  // 워크오더 반복일정 조회
  const getWorkOrderPreviewList = async (passParams: WorkOrderPreivew) => {
    let previewList: WorkOrderPreivew[] = [];

    const recurrenceEndDate = passParams.recurrenceEndDate; // 반복종료일
    const recurrenceType = passParams.recurrenceType; // 반복종료타입 (주/월/일)
    const isHoliday = passParams.isHoliday;

    // MONTHLY일 때만 월 시작 기준으로 monthlyStart 날짜 적용, 그 외에는 원래 startDate 사용
    const startDate =
      recurrenceType === "MONTHLY"
        ? moment(passParams.startDate).startOf("month").date(Number(passParams.monthlyStart)).format(YmdFormat.WITH_TIME_ZONE)
        : passParams.startDate;

    if (startDate && recurrenceEndDate && recurrenceType) {
      let previewParam: WorkOrderPreviewRequest = {
        recurrenceType,
        startDate: String(startDate),
        recurrenceEndDate: String(recurrenceEndDate),
        isHoliday,
      };

      if (recurrenceType === "WEEKLY") {
        previewParam = { ...previewParam, recurrenceDayOfWeekTypeList: passParams.recurrenceDayOfWeekTypeList };
      }

      const { data } = await getWorkOrderPreview(previewParam);
      const result = data.data.content;
      previewList = result.map((date) => {
        const returnDate: WorkOrderPreivew = {
          startDate: date,
          recurrenceEndDate: passParams.recurrenceEndDate,
          startTime: passParams.startTime,
          endTime: passParams.endTime,
          officerName: passParams.officerName,
          recurrenceType: passParams.recurrenceType,
          endDate: passParams.recurrenceType === "DAILY" ? date : moment(date).add(passParams.deadline, "days").format(YmdFormat.WITH_TIME_ZONE),
        };
        return returnDate;
      });
    }
    return previewList;
  };

  // 워크오더 취소 api
  const cancelWorkOrder = async (groupIds: string) => {
    await workOrderCancel({ groupIds });
  };

  // 워크오더 등록
  const createWorkOrder = async (workOrderSheetList: WorkOrderFormType[]) => {
    const requestWorkOrderSheet = workOrderSheetList.map((item) => {
      const { workOrderSheetAccessZoneList, ...rest } = item;
      return rest;
    });
    // return requestWorkOrderSheet;
    const { data } = await postWorkOrder({ workOrderSheetList: requestWorkOrderSheet });

    const passWorkSheetData = workOrderSheetList.map((item, index) => ({ ...item, id: data.data.content[index]?.id }));
    return passWorkSheetData;
  };

  // 워크오더 그룹 등록
  const createWorkOrderGroup = async (request: {
    workorderFormData: WorkOrderFormType;
    groupData: { recurrenceType: UnionRecurrenceType; isHoliday: boolean; recurrenceDayOfWeekType: string };
    previewList: WorkOrderPreivew[];
  }) => {
    const { workorderFormData, groupData, previewList } = request;
    let mediaFiles: MediaFile[] = [];
    const { data: groupIdRes } = await postWorkOrderGroupId({
      startDate: workorderFormData.startDate,
      recurrenceEndDate: workorderFormData.endDate,
      recurrenceType: groupData.recurrenceType,
      isHoliday: groupData.isHoliday,
      recurrenceDayOfWeekType: groupData.recurrenceDayOfWeekType,
    });

    if (groupIdRes.data) {
      if (workorderFormData.mediaList && workorderFormData.mediaList.length > 0) {
        const { data } = await moveMedias(workorderFormData.mediaList);
        mediaFiles = data.data.content;
      }

      const groupId = groupIdRes.data.content.id;
      const workOrderSheetList = previewList.map((item) => {
        const workOrderSheetAccessZoneList =
          workorderFormData?.workOrderSheetAccessZoneList?.map((zone) => ({
            ...zone,
            startTime: moment(item.startTime).format("HH:mm") || "",
            startDate: String(item.startDate || ""),
            endTime: moment(item.endTime).format("HH:mm") || "",
            endDate: String(item.endDate || ""),
          })) || [];

        return {
          ...workorderFormData,
          workOrderSheetAccessZoneList,
          startDate: item.startDate,
          mediaList: mediaFiles,
          endDate: moment(item.endDate).endOf("days").format(YmdFormat.WITH_TIME_ZONE),
          workOrderSheetGroupId: groupId,
        };
      });
      return await createWorkOrder(workOrderSheetList);
    }
  };

  return {
    defaultValues,
    getWorkOrderDetail,
    getBuildingManagement,
    getBuilding,
    editWorkOrder,
    getProviderDetail,
    workOrderCancel,
    postWorkOrder,
    postWorkOrderGroupId,
    moveMedias,
    getConnectedInfoList,
    onInviteVisitor,
    getBuildingOfficerInfo,
    getWorkOrderPreviewList,
    cancelWorkOrder,
    createWorkOrder,
    createWorkOrderGroup,
    getVisitorsList,
    onDeleteVisitor,
    getWorkOrderList,
    allCancelWorkOrderAndVisitor,
    retryInviteVisitor,
  };
};

export default useWorkOrder;
